import { Button as AntButton, Modal } from "antd";
import { FC, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getCommonCodeLabel } from "../../../../lib/store";
import { IFacility } from "../../../../models/homepageManagementFacility.model";
import styled from "styled-components";
import { BsArrowBarLeft, BsArrowBarRight } from "react-icons/bs";

export interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  facilityGbn: string;
  facilities: IFacility[];
}

const Block = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  width: 700px;
  height: 400px;
  
  & * {
    font-size: 40px;
  }

  .controller,
  .frame {
    margin: auto;
  }

  .controller {
    cursor: pointer;
    width: 50px;
  }

  img {
    max-width: 500px;
    max-height: 400px;
  }
`;

const ShowPreviewModal: FC<IProps> = ({
  visible, setVisible, facilityGbn, facilities
}) => {
  const { t } = useTranslation();
  const [seq, setSeq] = useState(0);

  const onSetSeq = (type: 'prev' | 'next') => {
    switch (type) {
      case 'prev':
        if (seq === 0) setSeq(facilities.length - 1);
        else setSeq(seq => seq - 1);
        break;
      case 'next':
        if (seq === facilities.length - 1) setSeq(0);
        else setSeq(seq => seq + 1);
        break;
    }
  }

  return (
    <Modal
      title={getCommonCodeLabel('HP0004', facilityGbn, 'ko') }
      width={750}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <Block>
        <div className="controller">
          <BsArrowBarLeft onClick={() => onSetSeq('prev')} />
        </div>
        <div className="frame">
          {
            facilities
              ? <img src={facilities[seq]?.facilityFile?.fileLocation} alt={t('homepage.facility.option1')} />
              : null
          }
        </div>
        <div className="controller">
          <BsArrowBarRight onClick={() => onSetSeq('next')} />
        </div>
      </Block>
    </Modal>    
  );
}

export default ShowPreviewModal;
